import { createSlice } from "@reduxjs/toolkit";

// Creator mode: shows the create-dataset / create-model options (docs/plans/CREATOR_MODE_PLAN.md).
// Deliberately in memory only, so every reload or new tab starts with it off.
export interface CreatorModeState {
  enabled: boolean;
}

const initialState: CreatorModeState = { enabled: false };

const creatorModeSlice = createSlice({
  name: "creatorMode",
  initialState,
  reducers: {
    toggleCreatorMode: (state) => {
      state.enabled = !state.enabled;
    },
  },
});

export const { toggleCreatorMode } = creatorModeSlice.actions;
export default creatorModeSlice.reducer;
